<!-- Slick Init -->
jQuery(document).ready(function($) {
  if (typeof $.fn.slick !== 'undefined') {
    $('.review-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
       fade:false,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true
    });

    $('.prev').on('click', function() {
      $('.review-slider').slick('slickPrev');
    });
    $('.next').on('click', function() {
      $('.review-slider').slick('slickNext');
    });
  } else {
    console.warn('Slick slider is not loaded.');
  }
});

jQuery(document).ready(function($) {
  if (typeof $.fn.slick !== 'undefined') {
    $('.video-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
       fade:true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 8000,
      infinite: true
    });

    $('.prev').on('click', function() {
      $('.video-slider').slick('slickPrev');
    });
    $('.next').on('click', function() {
      $('.video-slider').slick('slickNext');
    });
  } else {
    console.warn('Slick slider is not loaded.');
  }
});




